// 마지막으로 보던 지도 위치를 기억한다.
//
// 검색 결과 화면에는 지도가 없어 "어디서 찾는지"를 알 방법이 없다. 그렇다고 화면에
// 들어오자마자 위치 권한을 묻는 건 과하다. /places 에서 보던 지도 한가운데를 남겨 두면
// 권한 없이도 그 동네 기준으로 결과를 고를 수 있다.
const STORAGE_KEY = "hotple:last-map-center";

export const rememberLastMapCenter = (center) => {
  if (typeof window === "undefined") return;
  const lat = Number(center?.lat);
  const lng = Number(center?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ lat, lng }));
  } catch (error) {
    // 사파리 시크릿 모드처럼 저장이 막힌 곳도 있다. 없으면 없는 대로 간다.
  }
};

export const readLastMapCenter = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Number.isFinite(parsed?.lat) && Number.isFinite(parsed?.lng)
      ? parsed
      : null;
  } catch (error) {
    return null;
  }
};
